module.exports = __webpack_public_path__ + "img/img018.001f5485.png";